var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.654 2.58a.356.356 0 0 0-.508 0L4.732 9.77c-.06.061-.142.061-.203 0L.853 6.195a.356.356 0 0 0-.508 0 .356.356 0 0 0 0 .508l3.676 3.575a.848.848 0 0 0 .59.244.814.814 0 0 0 .589-.244l7.414-7.19a.358.358 0 0 0 .04-.508Z",
    fill: "#FFFDFC"
  })));
};
export default SvgCheckmark;